<template>
  <v-app>
    <main>
      <div
        v-if="showLoginPage"
        id="container"
        class="container"
      >
        <div class="form-container sign-in-container">
          <form @submit.prevent="submit">
            <img
              src="../../assets/Dibasys_logo.png"
              width="100px"
            >
            <h1 class="my-signin-style">
              Login
            </h1>
            <p>Enter your credentials to access your account.</p>
            <input
              id="email"
              v-model="email"
              type="email"
              placeholder="Email"
              name="email"
              required
            >
            <input
              id="password"
              v-model="password"
              type="password"
              placeholder="Enter your password"
              name="password"
              minlength="8"
              required
            >
            <div class="my-show-password-style">
              <label>
                <input
                  type="checkbox"
                  @click="showPassword()"
                >
                Show Password</label>
            </div>
            <router-link to="password/reset">
              Forgot your password?
            </router-link>
            <button
              type="submit"
            >
              <span>Sign In</span>
            </button>
          </form>
        </div>
        <div class="overlay-container">
          <div class="overlay">
            <div class="overlay-panel overlay-right">
              <div>
                <img src="../../assets/bg_login.png" alt="" width="100%">
              </div>
            </div>
          </div>
        </div>
      </div>
      <dashboard-core-footer v-if="showLoginPage" />
    </main>
    <welcome-page
      v-if="showWelcomePage"
      ref="welcomepage"
      :user-email="email"
      :user-password="password"
      @login-failed="loginFailed"
    />
    <centre-spinner
      :loading="loading"
    />
  </v-app>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import WelcomePage from './WelcomePage';

  export default {
    name: 'LoginNew',

    components: {
      'centre-spinner': spinner,
      DashboardCoreFooter: () => import('../dashboard/components/core/Footer'),
      'welcome-page': WelcomePage,
    },

    data: () => ({
      password: '',
      email: '',
      loading: false,
      logo: '../../assets/Dibasys_logo.png',
      showLoginPage: true,
      showWelcomePage: false,
    }),

    mounted () {
      this.checkValidSession();
    },

    methods: {
      submit () {
        this.showLoginPage = false;
        this.showWelcomePage = true;
      },
      clear () {
        this.$refs.form.reset();
        this.errors.clear('email');
      },
      checkValidSession () {
        var userExist = localStorage.getItem('ds-user');
        if (userExist !== null) {
          this.showLoginPage = false;
          this.showWelcomePage = true;
        }
      },
      showPassword () {
        var passwordStatus = document.getElementById('password');
        if (passwordStatus.type === 'password') {
          passwordStatus.type = 'text';
        } else {
          passwordStatus.type = 'password';
        }
      },
      loginFailed () {
        this.showWelcomePage = false;
        this.showLoginPage = true;
      },
    },
  };
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');
* {
box-sizing: border-box;
font-family: "DM Sans", serif !important;
}
h1 {
font-weight: bold;
display: inline;
}
h2 {
text-align: center;
}
.my-dbs-style {
  color: #FF3700;
}
.my-signage-style {
  color: #ECEFF1;
}
.my-welcome-style {
  color: #ECEFF1;
}
p {
font-size: 16px;
line-height: 20px;
letter-spacing: 0.5px;
color: #000;
}
span {
font-size: 12px;
}
a {
color: #37474F;
font-size: 14px;
text-decoration: none;
margin: 15px 0;
}
button {
border-radius: 5px;
border: 1px solid #0000;
background-color: #000;
color: #FFFFFF;
font-size: 12px;
font-weight: bold;
padding: 12px 45px;
letter-spacing: 1px;
text-transform: uppercase;
}
button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}
button span:after {
  content: '\00bb';
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.5s;
}
button:hover span {
  padding-right: 10px;
}

button:hover span:after {
  opacity: 1;
  right: 0;
}
form {
background-color: #fff;
display: flex;
justify-content: center;
flex-direction: column;
padding: 0 60px;
height: 100%;
width: 100%;
}
input {
background-color: #fff;
border: none;
padding: 12px 15px;
margin: 8px 0;
width: 100%;
border: 1px solid #000;
border-radius: 5px;
}
.container {
padding: 16px;
object-fit: contain;
}
.form-container {
position:absolute;
top: 0;
height: 100%;
bottom: 200%;
}
.sign-in-container {
right: 0;
width: 35%;
height: 100%;
z-index: 2;
}
.overlay-container {
position: absolute;
top: 0;
left: 0;
width: 60%;
height: 100%;
overflow: hidden;
transition: transform 0.6s ease-in-out;
z-index: 100;
padding: 60px;
background:#ffe8e4;
}
.overlay {
background: #ffe8e4;
background-position: 0 0;
color: #FFFFFF;
position: relative;
left: -100%;
height: 100%;
width: 200%;
/* background-image: url('../../assets/bg_login.jpg');
background-repeat: no-repeat;
background-size: cover; */
padding: 30px;
}
.overlay-panel {
position: absolute;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
padding: 0 40px;
text-align: center;
top: 0;
height: 100%;
width: 50%;
}
.overlay-right {
right: 0;
transform: translateX(0);
}
.my-signin-style {
  color: #37474F;
}
.fa {
border: 1px solid #DDDDDD;
border-radius: 50%;
display: inline-flex;
justify-content: center;
align-items: center;
margin: 0 5px;
height: 40px;
width: 40px;
margin: 40px 0;
margin-right: 15px;
}
.fa:hover {
  opacity: 0.7;
}
.fa-facebook {
  background: #3B5998;
  color: white;
}
.fa-twitter {
  background: #55ACEE;
  color: white;
}
.fa-instagram {
  background: radial-gradient(circle at 33% 100%, #fed373 4%, #f15245 30%, #d92e7f 62%, #9b36b7 85%, #515ecf);
  color: white;
}
.fa-youtube {
  background: #bb0000;
  color: white;
}
@media (max-width: 767px) {
  .overlay-container {
    display: none;
  }
}
@media (max-width: 767px) {
  .sign-in-container {
    width: 100%;
    display: block;
  }
}
input[type="checkbox"] {
  width: 13px;
  height: 13px;
  padding: 0;
  margin:0;
  vertical-align: middle;
  position: relative;
  top: -1px;
  *overflow: hidden;
}
.my-show-password-style {
  display: flex;
  width: 80%;
}
label {
  color: #37474F;
  font-size: 14px;
  text-decoration: none;
}
::v-deep ::-webkit-scrollbar {
  width: 0;
  background: transparent;
}
</style>
